import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const SelectChildrenForPin = React.lazy(() => import('./select-children-for-pin').then(module => ({ default: module.SelectChildrenForPin })));
/** Only sites with the feature reach this screen, so it loads on demand */
export const SelectChildrenRoute = () => (_jsx(React.Suspense, { fallback: null, children: _jsx(SelectChildrenForPin, {}) }));
